<!-- 开票数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                  :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 提取信息 -->
                        <div v-if="scope.index == 0">
                           <el-form id="mainInfo" @submit.native.prevent class="baseForm" label-width="100px"
                              :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                    :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                    :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <!-- 系统字段 -->
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <div v-if="formOneValue.isReserved == 0">
                                       <!-- 开票日期 -->
                                       <df-date v-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                          :isdisabled="formOneValue.isChange == 0"
                                          v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                       <!-- 开票单位 -->
                                       <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                          :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                          effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                          placement="bottom-start">
                                          <el-input v-model="sendDataInfo[formOneValue.entityField]" clearable
                                             @keyup.enter.native="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                             :disabled="formOneValue.isChange == 0">
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <el-select clearable size="mini"
                                          v-else-if="formOneValue.fieldType == 'formatter'"
                                          :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                          v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                             :key="item.key" :label="item.value" :value="item.key"></el-option>
                                       </el-select>
                                       <el-input v-else-if="formOneValue.entityField == 'remark'" type="textarea"
                                          :disabled="formOneValue.isChange == 0"
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          maxlength="200"></el-input>
                                       <el-input v-else :disabled="formOneValue.isChange == 0"
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"></el-input>
                                    </div>
                                    <!-- 扩展字段 -->
                                    <div v-if="formOneValue.isReserved == 1">
                                       <!-- 自填 -->
                                       <el-input v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          v-if="formOneValue.operatType == 0" :disabled="formOneValue.isChange == 0"
                                          :maxlength="$store.state.inputLength"></el-input>
                                       <!-- 选择数据来源 -->
                                       <el-input v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :disabled="formOneValue.isChange == 0" v-else
                                          :maxlength="$store.state.inputLength"
                                          @focus="openSearch(formOneValue.searchId)"></el-input>
                                    </div>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField"
                                    v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                    <span v-if="formOneValue.isRift == 1">
                                       <a
                                          @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span
                                          v-if="sendDataInfo[formOneValue.entityField]">{{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                       disabled @change="$forceUpdate()"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                          :key="item.key" :label="item.value" :value="item.key"></el-option>
                                    </el-select>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <div style="margin: 10px 0;">
                              <el-button type="primary" size="mini" @click="getExtractBill">选择单据</el-button>
                           </div>
                           <!-- 明细信息 -->
                           <el-table :data="sendDataInfo.detailList" @selection-change="detailSelectionChange" border
                              size="mini" :height="mxHeight" ref="psdocumentsdetailTable">
                              <el-table-column type="selection" width="40"
                                 v-if="dataActionBox.actionType != 2"></el-table-column>
                              <el-table-column align="center" :prop="formOneValue.entityField"
                                 :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm"
                                 :key="formOneKey" v-if="formOneValue.isShow == 1"
                                 show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                 <template slot="header">
                                    <div>
                                       <el-tooltip :content="formOneValue.showField" placement="top">
                                          <div class="long_title"><span>{{ formOneValue.showField }}</span></div>
                                       </el-tooltip>
                                    </div>
                                 </template>

                                 <template slot-scope="scope">
                                    <!-- 系统字段 -->
                                    <div v-if="formOneValue.isReserved == 0">
                                       <!-- 生产日期 -->
                                       <template v-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </template>
                                       <el-input v-else-if="formOneValue.fieldType == 'search'"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          clearable
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <el-select clearable size="mini"
                                          v-else-if="formOneValue.fieldType == 'formatter'"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                          @change="$forceUpdate()"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          placeholder="请选择">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                             :key="item.key" :label="item.value" :value="item.key"></el-option>
                                       </el-select>
                                       <!-- 开票数量 -->
                                       <input class="kaipiao_num" v-else-if="formOneValue.entityField == 'ddinCount'"
                                          @input="calculatePrice(5, scope.$index)" type="number"
                                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :min="sendDataInfo.detailList[scope.$index].ddinCount < 0 ? sendDataInfo.detailList[scope.$index].treatCount : 0"
                                          :max="sendDataInfo.detailList[scope.$index].ddinCount < 0 ? 0 : sendDataInfo.detailList[scope.$index].treatCount"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2">

                                       <!-- 总金额 -->
                                       <el-input v-else-if="formOneValue.entityField == 'money'" type="number"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2"></el-input>
                                       <!-- @change="calculatePrice(3,scope.$index)" -->
                                       <!-- 含税金额 -->
                                       <!-- @input="calculatePrice(4,scope.$index)" -->
                                       <el-input v-else-if="formOneValue.entityField == 'psmoney'" type="number"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2"></el-input>
                                       <!-- @change="calculatePrice(4,scope.$index)" -->
                                       <!-- 税额 -->
                                       <el-input v-else-if="formOneValue.entityField == 'taxMoney'" type="number"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2"></el-input>
                                       <!-- 备注 -->
                                       <el-input v-else-if="formOneValue.entityField == 'remark'"
                                          v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2"></el-input>
                                       <span
                                          v-else>{{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</span>
                                    </div>
                                    <!-- 扩展字段 -->
                                    <div v-else-if="formOneValue.isReserved == 1 || dataActionBox.actionType == 2">
                                       <!-- 自填 -->
                                       <el-input
                                          v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength"
                                          :disabled="dataActionBox.actionType == 1"></el-input>
                                       <!-- 选择数据来源 -->
                                       <el-input
                                          v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          v-else :maxlength="$store.state.inputLength"
                                          :disabled="dataActionBox.actionType == 1 || dataActionBox.actionType == 2"></el-input>
                                    </div>
                                 </template>
                              </el-table-column>
                           </el-table>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
               @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>

         <!-- 检索方案 -->
         <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
               @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
         </el-dialog>
         <!-- 提取方案 -->
         <el-dialog title="提取表单" v-if="DialogExtract" :visible.sync="DialogExtract" width="100%" top="1vh"
            :modal-append-to-body='true' :append-to-body="true">
            <PurchaseInvoiceExtract ref="invoiceExtract" :parentType="true" :invoiceExtractData="invoiceExtractData"
               @invoiceExtractMethods="getExData" />
         </el-dialog>
         <printPlan ref="printPlan"></printPlan>
         <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
      </div>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: 'queryPsDrawBillAction',
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         isLoaded: false,
         dataActionBox: {
            showStatus: false,
            openMode: 'ltr' || 'rtl',
            boxTitle: '新增' || '编辑',
            actionType: 0, // 0新增，1修改
         },
         invoiceExtractData: {
            smId: '', //开票单位
            smName: '', //开票单位
            start: '',
            end: '',
            coName: '',
            coId: "",
            businessId: "",
         },
         sendDataInfo: {
            start: '',
            end: '',
            billType: "",    //	发票类型
            smId: "",    //	单位ID
            smName: "",    //	单位ID
            remark: "",    //	备注
            totalMoney: "",    //	含税总金额
            detailList: [],
         },
         detailSelectList: [], //明细选择数据
         mxForm: [],
         tabForm: [],
         footForm: [],
         showTabs: '',
         formDataList: [],
         selectedDetailsIndex: 0,
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         sField: '',
         DialogExtract: false, //提取
         smId: '',
         seWidth: '0',
         mxHeight: 0, //动态表格高度
         parentSearchData: {},
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'sendDataInfo.smName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.sendDataInfo.smId = ''
               Object.keys(this.sendDataInfo).forEach(key => {
                  if (key == 'detailList') {
                     this.sendDataInfo[key] = []
                  } else if (key == 'totalMoney') {
                     this.sendDataInfo[key] = 0
                  } else if (key == 'start' || key == 'end') {

                  }
                  else {

                     this.sendDataInfo[key] = ''
                  }
               })
            }
         },
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.isLoaded = true;
         this.openBox();
      });
   },
   //方法集合
   methods: {
      drawerCancel() {
         this.$emit("drawerCancel", true);
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      //获取提取单据
      getExtractBill() {
         for (const key in this.invoiceExtractData) {
            if (Object.hasOwnProperty.call(this.invoiceExtractData, key)) {
               this.invoiceExtractData[key] = this.sendDataInfo[key];
            }
         }
         if (this.invoiceExtractData.smId == '') {
            this.$message({
               message: '请先选择单位',
               type: 'error'
            })
            return false;
         } else if (this.invoiceExtractData.start == '' || this.invoiceExtractData.end == '') {
            this.$message({
               message: '请填写日期',
               type: 'error'
            })
            return false;
         }
         this.DialogExtract = true;
      },
      // 获取 提取单数据
      async getExData(res) {
         let val = JSON.parse(JSON.stringify(res))
         console.log('提取', val);
         if (val != "" || val != undefined) {
            var arr = JSON.parse(JSON.stringify(val.detailData))
            if (this.sendDataInfo.detailList.length > 0) {
               this.sendDataInfo.detailList.forEach((item1) => {
                  arr.forEach((item, index) => {
                     if (item1.dapdId == item.dapdId) {
                        arr.splice(index, 1)
                     }
                  })

               })
               this.sendDataInfo.detailList = this.sendDataInfo.detailList.concat(arr)
            } else {
               this.sendDataInfo.detailList = arr
            }
            this.$refs.psdocumentsdetailTable.toggleAllSelection() //table全选
            this.detailSelectList = JSON.parse(JSON.stringify(this.sendDataInfo.detailList)) //明细选中
            this.calculationMainData() //计算主表单数据
         } else {
         }
         this.DialogExtract = false
      },
      getExWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split('<br/>')
         let newArr = []
         const h = this.$createElement
         for (const i in txtArr) {
            newArr.push(h('p', null, txtArr[i]))
         }
         this.$alert(h('div', null, newArr), '提示', {
            confirmButtonText: '确定',
            callback: action => { }
         })
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      //检索带回数据
      changeInputModel(val) {
         console.log('检回', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认新增
      async sendDataAction(formName1) {
         let flag = false
         this.$refs[formName1].validate((valid) => {
            if (valid) {

            } else {
               this.$message({
                  message: '请完善信息',
                  type: 'error'
               })
               flag = true
               return false;
            }
         })
         if (flag) return false;

         if (this.sendDataInfo.detailList.length < 1) {
            this.$message({
               message: '请先提取有效单据',
               type: 'error'
            });
            return false
         }

         for (let j = 0; j < this.sendDataInfo.detailList.length; j++) {
            const itemvs = this.sendDataInfo.detailList[j];
            if (itemvs.ddinCount == 0) {
               this.$message({
                  message: '请填写合理的开票数量',
                  type: 'error'
               });
               this.$set(itemvs, 'ddinCount', 0)
               return false
            }
         }

         let sendObj = {}
         for (const key in this.sendDataInfo) {
            if (typeof this.sendDataInfo[key] == 'object' || Array.isArray(this.sendDataInfo[key])) {
               if (key == 'detailList') {
                  sendObj[key] = this.sendDataInfo[key].filter((v) => {
                     for (let j = 0; j < this.detailSelectList.length; j++) {
                        const ele = this.detailSelectList[j]
                        if (v.dapdId == ele.dapdId) return v
                     }
                  })
               } else {
                  sendObj[key] = JSON.parse(JSON.stringify(this.sendDataInfo[key]))
               }
            } else {
               sendObj[key] = this.sendDataInfo[key]
            }
         }

         let responseData
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.psdrawbilladd(sendObj)
         } else {
            responseData = await this.$http.sudrawbillUpdate(sendObj)
         }

         if (responseData.status == 200) {
            this.$message({
               message: '操作成功',
               type: 'success'
            });
            if (this.dataActionBox.actionType == 0) {
               this.$refs.operSelect.openBox(responseData.result);
            } else {
               this.$emit("drawerCancel");
               this.$refs[formName1].resetFields()
            }
         } else {
            let txtArr = responseData.message.split('<br/>')
            let newArr = []
            const h = this.$createElement
            for (const i in txtArr) {
               newArr.push(h('p', null, txtArr[i]))
            }
            this.$message({
               message: h('div', null, newArr),
               type: 'error'
            });
         }
      },
      conAdd() {
         this.init()
         this.$refs[formName1].resetFields()
      },
      //明细选择触发
      detailSelectionChange(val) {
         this.detailSelectList = JSON.parse(JSON.stringify(val))
         this.calculationMainData() //计算主表单数据
      },
      //明细选择完毕
      detailSelectOver() {
         if (this.detailSelectList.length < 1) {
            this.$message({
               message: '请先选中明细信息',
               type: 'error'
            })
            return false
         }
         this.calculationMainData() //计算主表单数据
      },

      //计算主表单数据
      calculationMainData() {
         this.sendDataInfo.totalMoney = 0
         this.sendDataInfo.totalCount = 0
         this.sendDataInfo.detailList.forEach(b => { //明细
            // 税额 = 含税金额 - 金额   绝对值
            this.$set(b, 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(b.psmoney, b.money)))
            var arr = this.detailSelectList.filter(v => {
               return v.dapdId == b.dapdId
            })
            if (arr.length > 0) {
               b.psmoney = parseFloat(b.psmoney)
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, b.psmoney))
               this.sendDataInfo.totalCount = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalCount, (b.ddinCount || 0)))
            }
         })
      },

      // 计算价格
      calculatePrice(num, index) {
         var info = this.sendDataInfo.detailList[index]
         if (info.ddinCount < 0) {
            if (info.ddinCount < info.treatCount) {
               this.$message({
                  message: '开票数量不能小于待开票数量',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            } else if (info.ddinCount > 0) {
               this.$message({
                  message: '开票数量不能大于 0',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            }
         } else {
            if (info.ddinCount > info.treatCount) {
               this.$message({
                  message: '开票数量不能大于待开票数量',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            } else if (info.ddinCount < 0) {
               this.$message({
                  message: '开票数量不能小于 0',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            }
         }
         info.price = parseFloat(info.price) //单价
         info.psprice = parseFloat(info.psprice) //含税单价
         info.money = parseFloat(info.money) //金额
         info.psmoney = parseFloat(info.psmoney) //含税金额
         info.inRate = parseFloat(info.inRate) //销项税率
         info.ddinCount = parseFloat(info.ddinCount) //开票数量
         this.$set(this.sendDataInfo.detailList[index], 'taxMoney', 0)
         //  通过数量计算 计算金额 单价*数量
         this.sendDataInfo.detailList[index].money = this.$common.getDecimalInfo(3, NP.times(info.price, info.ddinCount))

         // 计算含税金额 含税价格*数量
         var moneyOne = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.ddinCount))
         this.sendDataInfo.detailList[index].psmoney = moneyOne

         // 税额 = 含税金额 - 金额   绝对值
         this.$set(this.sendDataInfo.detailList[index], 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(moneyOne, info.money)))
         console.log(this.detailSelectList);

         for (let i = 0; i < this.detailSelectList.length; i++) { //选中内改变才计算
            if (this.detailSelectList[i].dasmId == info.dasmId) {
               this.calculationMainData() //计算主表单数据
               break
            }
         }
      },

      //取消
      initActionBox(formName1) {
         if (this.dataActionBox.actionType == 2) {
            this.init()
            this.$refs[formName1].resetFields()
            this.$emit("drawerCancel");
         } else {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               this.init()
               this.$refs[formName1].resetFields()
               this.$emit("drawerCancel");
            }).catch(() => { })
         }
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            if (key == 'detailList') {
               this.sendDataInfo[key] = []
            } else {
               this.sendDataInfo[key] = ''
            }
         }
         //detailList
         this.sendDataInfo.start = this.$common.getStartTime()
         this.sendDataInfo.end = this.$common.getEndTime()

         this.sendDataInfo.totalMoney = 0
      },
      // 默认值
      initDefaultValue() {
         this.tabForm.forEach(item => {
            if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
               this.sendDataInfo[item.entityField] = item.defaultValue
            }
         })
      },

      //上级流入
      openBox() {
         console.log('this.actionData.cate', this.actionData);
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         this.showTabs = this.formDataList[0].jciName
         var oldData = JSON.parse(JSON.stringify(this.actionData.oldData))
         this.filterMainField()
         this.init()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = '新增信息'
            this.dataActionBox.openMode = 'ltr'
            console.log(this.invoiceExtractData)
         } else {
            if (this.dataActionBox.actionType == 1) {
               this.dataActionBox.boxTitle = '编辑信息';
            } else {
               this.dataActionBox.boxTitle = "查看信息";
            }
            this.dataActionBox.openMode = 'rtl'
            for (let key in oldData) {
               this.sendDataInfo[key] = oldData[key];
            }
            this.invoiceExtractData['smId'] = oldData.smId
            this.invoiceExtractData['smName'] = oldData.smName
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
            console.log(this.invoiceExtractData, "********************")
         })
      },

      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
            }
         })
         var arr = [{ entityField: "detailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "start", (new Date().getTime() - 31 * 24 * 3600 * 1000))
         this.$set(this.sendDataInfo, "end", this.$moment().valueOf())
      },

      //数字转中文大写
      changeNumMoneyToChinese(money) {
         var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
         var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
         var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
         var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
         var cnInteger = "整"; //整数金额时后面跟的字符
         var cnIntLast = "元"; //整型完以后的单位
         var maxNum = 999999999999999.9999; //最大处理的数字
         var IntegerNum; //金额整数部分
         var DecimalNum; //金额小数部分
         var ChineseStr = ""; //输出的中文金额字符串
         var parts; //分离金额后用的数组，预定义    
         var Symbol = "";//正负值标记
         if (money == "") {
            return "零";
         }

         money = parseFloat(money);
         if (money >= maxNum) {
            alert('超出最大处理数字');
            return "";
         }
         if (money == 0) {
            ChineseStr = cnNums[0] + cnIntLast + cnInteger;
            return ChineseStr;
         }
         if (money < 0) {
            money = -money;
            Symbol = "负 ";
         }
         money = money.toString(); //转换为字符串
         if (money.indexOf(".") == -1) {
            IntegerNum = money;
            DecimalNum = '';
         } else {
            parts = money.split(".");
            IntegerNum = parts[0];
            DecimalNum = parts[1].substr(0, 4);
         }
         if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
            var zeroCount = 0;
            var IntLen = IntegerNum.length;
            for (var i = 0; i < IntLen; i++) {
               var n = IntegerNum.substr(i, 1);
               var p = IntLen - i - 1;
               var q = p / 4;
               var m = p % 4;
               if (n == "0") {
                  zeroCount++;
               }
               else {
                  if (zeroCount > 0) {
                     ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
               }
               if (m == 0 && zeroCount < 4) {
                  ChineseStr += cnIntUnits[q];
               }
            }
            ChineseStr += cnIntLast;
            //整型部分处理完毕
         }
         if (DecimalNum != '') { //小数部分
            var decLen = DecimalNum.length;
            for (var i = 0; i < decLen; i++) {
               var n = DecimalNum.substr(i, 1);
               if (n != '0') {
                  ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
               }
            }
         }
         if (ChineseStr == '') {
            ChineseStr += cnNums[0] + cnIntLast + cnInteger;
         } else if (DecimalNum == '') {
            ChineseStr += cnInteger;
         }
         ChineseStr = Symbol + ChineseStr;

         return ChineseStr;
      },

   },

}
</script>

<style scoped>
::v-deep .el-drawer .el-drawer__header {
   height: 0;
   padding: 0;
   margin: 0;
   overflow: hidden;
}

.detailForm {
   margin-bottom: 0.2rem;
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   align-items: center;
}

.detailForm .el-input {
   width: auto;
}

.table_button_box {
   height: 200px;
   background-color: red;
}

/* .table_content_box {
    height: 500px !important;
    overflow-y: auto;
} */

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.kaipiao_num {
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   height: 28px;
   width: 100%;
   line-height: 40px;
   padding: 0 15px;
   outline: 0;
}
</style>
